/* GemKrishna – Buy Rudraksha page (sections/gk-rudraksha-shop.liquid).
   Enhancement only: search, origin pills, filter dropdowns (each clearable), sorting, size -> price
   display, the per-bead lab report toggle and add-to-cart without a reload. Prices and variant IDs are
   read from the server-rendered cards, never computed here. */
(function () {
  'use strict';
  var root = document.querySelector('[data-gkrs]');
  if (!root) return;

  var grid = root.querySelector('[data-gkrs-grid]');
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.gkrs-card'));
  var filters = root.querySelector('[data-gkrs-filters]');
  var countEl = root.querySelector('[data-gkrs-count]');
  var emptyEl = root.querySelector('[data-gkrs-empty]');
  var activeBox = root.querySelector('[data-gkrs-active]');
  var activeList = root.querySelector('[data-gkrs-active-list]');
  var resetBtns = root.querySelectorAll('[data-gkrs-reset]');
  var shopEl = root.querySelector('#gkrs-shop');
  var qInput = root.querySelector('[data-gkrs-q]');
  var qClear = root.querySelector('[data-gkrs-q-clear]');
  var pills = Array.prototype.slice.call(root.querySelectorAll('[data-gkrs-origin]'));
  var moreBtn = root.querySelector('[data-gkrs-more]');
  var moreRow = root.querySelector('#gkrs-more-filters');
  var moreN = root.querySelector('[data-gkrs-more-n]');
  var reportBtn = document.querySelector('[data-gkrs-report-btn]');
  var total = cards.length;
  var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var REPORT_PROPS = { 'For': 'Rudraksha beads under ₹1,000 in this order' };
  // Report / X-ray rule shared with the product pages (assets/gk-rb-rules.js); minimal fallback if it failed to load
  var RULES = window.GKRB || {
    REPORT_FROM: 100000,
    label: function (p) { return p >= 100000 ? 'Free GJSPC X-ray lab report included' : ''; }
  };
  function maxQty(sel) { return Math.max(1, Math.min(108, Number(sel && sel.max) || 108)); }
  function stockNote(max) {
    return 'Only ' + max + (max === 1 ? ' bead' : ' beads') + ' of this size can be ordered online. For more, message us on WhatsApp.';
  }

  // Dropdown filters. "key" is the state property and the URL parameter.
  var controls = [
    { key: 'type', label: 'Mukhi', el: root.querySelector('[data-gkrs-type]') },
    { key: 'size', label: 'Size', el: root.querySelector('[data-gkrs-size]') },
    { key: 'budget', label: 'Budget', el: root.querySelector('[data-gkrs-budget-select]') }
  ];
  var sortSel = root.querySelector('[data-gkrs-sort]');
  var state = { q: '', origin: '', type: '', size: '', budget: '', sort: 'rank' };
  var lastPick = '';

  /* ---------- search ---------- */
  // Words that every Rudraksha shares; they are ignored so "5 mukhi rudraksha price" finds 5 Mukhi.
  var STOP = ' rudraksha rudraksh rudraksa rudrakasha rudraksham rudrakhsa rudrax रुद्राक्ष bead beads dana mani original natural genuine real buy online shop price cost rate lab certified certificate report with and the of for in from best ';
  function norm(s) {
    return String(s || '').toLowerCase()
      .replace(/[^a-z0-9ऀ-ॿ]+/g, ' ')
      .replace(/(\d)([a-z])/g, '$1 $2')
      .replace(/([a-z])(\d)/g, '$1 $2')
      .replace(/\b(\d+) mm\b/g, '$1mm')
      .replace(/\b(\d+) faced?\b/g, '$1 mukhi')
      .replace(/\bmukh[iy]?e*\b|\bmukhee\b|\bmukhy\b/g, 'mukhi')
      .trim();
  }
  function tokens(s) {
    return norm(s).split(/\s+/).filter(function (t) { return t && STOP.indexOf(' ' + t + ' ') === -1; });
  }
  cards.forEach(function (c, i) {
    c.dataset.order = i;
    var words = tokens(c.dataset.search || '');
    // Sizes become "10mm 12mm" tokens so a search for "10 mm" never matches 10 Mukhi
    Array.prototype.forEach.call(c.querySelectorAll('option[data-size]'), function (o) {
      (o.dataset.size.match(/\d+(?:\.\d+)?/g) || []).forEach(function (n) { words.push(n + 'mm'); });
    });
    c._words = words;
  });
  function matchesQuery(card, qt) {
    for (var i = 0; i < qt.length; i++) {
      var t = qt[i], hit = false;
      for (var j = 0; j < card._words.length; j++) {
        var w = card._words[j];
        if (/^\d/.test(t) ? w === t : w.indexOf(t) === 0) { hit = true; break; }
      }
      if (!hit) return false;
    }
    return true;
  }

  /* ---------- helpers ---------- */
  function sizeOptions(card) {
    return Array.prototype.slice.call(card.querySelectorAll('option[data-price]'));
  }
  function budgetRange() {
    if (!state.budget) return null;
    var p = state.budget.split('-');
    return [Number(p[0]) * 100, p[1] ? Number(p[1]) * 100 : Infinity];
  }
  function inRange(pr, range) { return !range || (pr >= range[0] && pr < range[1]); }
  // Cheapest purchasable size on a card that satisfies the size and budget filters (option or null).
  function bestOption(card) {
    var range = budgetRange(), best = null;
    sizeOptions(card).forEach(function (o) {
      if (o.disabled) return;
      if (state.size && o.dataset.size !== state.size) return;
      var pr = Number(o.dataset.price);
      if (!inRange(pr, range)) return;
      if (best === null || pr < Number(best.dataset.price)) best = o;
    });
    return best;
  }
  // Lowest matching price on a card (in paise), Infinity for enquiry-only, null when it does not match.
  function matchPrice(card) {
    if (!sizeOptions(card).length) {
      if (card.hasAttribute('data-enquiry')) return (state.size || state.budget) ? null : Infinity;
      if (state.size || !card.dataset.min) return null;
      var m = Number(card.dataset.min);
      return inRange(m, budgetRange()) ? m : null;
    }
    var o = bestOption(card);
    return o ? Number(o.dataset.price) : null;
  }
  function optionText(sel, value) {
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === value) return sel.options[i].text.replace(/\s*\(.*\)$/, '');
    }
    return value;
  }
  function optionExists(sel, v) {
    if (!v) return false;
    return Array.prototype.some.call(sel.options, function (o) { return o.value === v; });
  }
  function pillExists(v) {
    return pills.some(function (p) { return p.dataset.gkrsOrigin === v; });
  }
  function dropdownCount() {
    return controls.filter(function (c) { return state[c.key]; }).length;
  }
  function activeCount() {
    return dropdownCount() + (state.origin ? 1 : 0) + (state.q ? 1 : 0);
  }

  /* ---------- filtering ---------- */
  function apply(fromUser) {
    var shown = [];
    var qt = tokens(state.q);
    // When the size or budget filter changes, each bead switches to its cheapest matching size
    var pickKey = state.size + '|' + state.budget;
    var repick = pickKey !== lastPick;
    lastPick = pickKey;
    cards.forEach(function (card) {
      var ok = true;
      if (state.origin && card.dataset.origin !== state.origin) ok = false;
      if (ok && state.type && card.dataset.type !== state.type) ok = false;
      if (ok && qt.length && !matchesQuery(card, qt)) ok = false;
      var price = ok ? matchPrice(card) : null;
      if (price === null) ok = false;
      card.hidden = !ok;
      card.dataset.match = ok ? price : '';
      if (ok) shown.push(card);
      if (repick && card._pick) card._pick(state.size || state.budget ? bestOption(card) : null);
    });

    shown.sort(function (a, b) {
      if (state.sort === 'price-asc' || state.sort === 'price-desc') {
        var pa = Number(a.dataset.match), pb = Number(b.dataset.match);
        if (!isFinite(pa)) return 1;
        if (!isFinite(pb)) return -1;
        if (pa !== pb) return state.sort === 'price-asc' ? pa - pb : pb - pa;
      }
      return Number(a.dataset.order) - Number(b.dataset.order);
    });
    var frag = document.createDocumentFragment();
    shown.forEach(function (c) { frag.appendChild(c); });
    cards.forEach(function (c) { if (c.hidden) frag.appendChild(c); });
    grid.appendChild(frag);

    countEl.textContent = activeCount() ? 'Showing ' + shown.length + ' of ' + total + ' Rudraksha types' : total + ' Rudraksha types';
    emptyEl.hidden = shown.length > 0;
    grid.hidden = shown.length === 0;
    renderActive();
    syncControls();
    if (fromUser) writeUrl();
  }

  // Selected filters as removable chips, plus "Clear all"
  function chip(text, label, onRemove) {
    var li = document.createElement('li');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'gkrs-active__chip';
    b.setAttribute('aria-label', 'Remove ' + label + ': ' + text);
    b.appendChild(document.createTextNode(text));
    var x = document.createElement('span');
    x.setAttribute('aria-hidden', 'true');
    x.textContent = '×';
    b.appendChild(x);
    b.addEventListener('click', onRemove);
    li.appendChild(b);
    activeList.appendChild(li);
  }
  function renderActive() {
    activeList.innerHTML = '';
    if (state.q) chip('“' + state.q + '”', 'search', function () { state.q = ''; apply(true); qInput.focus(); });
    if (state.origin) {
      var p = pills.filter(function (x) { return x.dataset.gkrsOrigin === state.origin; })[0];
      chip(p ? p.firstChild.textContent.trim() : state.origin, 'origin', function () { state.origin = ''; apply(true); });
    }
    controls.forEach(function (c) {
      if (!state[c.key]) return;
      chip(optionText(c.el, state[c.key]), 'filter ' + c.label, function () { state[c.key] = ''; apply(true); c.el.focus(); });
    });
    activeBox.hidden = activeCount() === 0;
  }

  function syncControls() {
    controls.forEach(function (c) {
      c.el.value = state[c.key];
      c.el.closest('.gkrs-dd').classList.toggle('is-active', !!state[c.key]);
    });
    sortSel.value = state.sort;
    pills.forEach(function (p) { p.setAttribute('aria-pressed', String(p.dataset.gkrsOrigin === state.origin)); });
    if (qInput.value.trim() !== state.q) qInput.value = state.q;
    qClear.hidden = !state.q;
    var n = dropdownCount() + (state.sort !== 'rank' ? 1 : 0);
    moreN.hidden = !n;
    moreN.textContent = n;
  }

  /* ---------- URL state (shareable filtered views, e.g. ad links ?origin=nepal&type=5-mukhi) ---------- */
  function readUrl() {
    var q = new URLSearchParams(location.search);
    controls.forEach(function (c) {
      var v = (q.get(c.key) || '').split(',')[0];
      state[c.key] = optionExists(c.el, v) ? v : '';
    });
    var o = (q.get('origin') || '').split(',')[0];
    state.origin = pillExists(o) && o ? o : '';
    state.q = (q.get('q') || '').slice(0, 60);
    state.sort = optionExists(sortSel, q.get('sort')) ? q.get('sort') : 'rank';
  }
  function writeUrl() {
    var q = new URLSearchParams(location.search);
    ['q', 'origin'].concat(controls.map(function (c) { return c.key; })).forEach(function (k) {
      q.delete(k);
      if (state[k]) q.set(k, state[k]);
    });
    q.delete('sort');
    if (state.sort !== 'rank') q.set('sort', state.sort);
    var s = q.toString();
    history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash);
  }

  /* ---------- controls ---------- */
  controls.forEach(function (c) {
    c.el.addEventListener('change', function () { state[c.key] = c.el.value; apply(true); });
  });
  sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(true); });
  pills.forEach(function (p) {
    p.addEventListener('click', function () { state.origin = p.dataset.gkrsOrigin; apply(true); });
  });
  var qTimer;
  qInput.addEventListener('input', function () {
    clearTimeout(qTimer);
    qTimer = setTimeout(function () { state.q = qInput.value.trim().slice(0, 60); apply(true); }, 160);
  });
  qInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); clearTimeout(qTimer); state.q = qInput.value.trim().slice(0, 60); apply(true); qInput.blur(); }
  });
  qClear.addEventListener('click', function () { state.q = ''; apply(true); qInput.focus(); });
  moreBtn.addEventListener('click', function () {
    var open = moreBtn.getAttribute('aria-expanded') !== 'true';
    moreBtn.setAttribute('aria-expanded', String(open));
    moreRow.classList.toggle('is-open', open);
  });
  Array.prototype.forEach.call(resetBtns, function (b) {
    b.addEventListener('click', function () {
      controls.forEach(function (c) { state[c.key] = ''; });
      state.origin = '';
      state.q = '';
      apply(true);
    });
  });

  // "Show Nepal Rudraksha" / Mukhi / benefit links in the guides filter the list and scroll to it
  Array.prototype.forEach.call(root.querySelectorAll('[data-gkrs-quick]'), function (a) {
    a.addEventListener('click', function (e) {
      try {
        var q = JSON.parse(a.dataset.gkrsQuick);
        e.preventDefault();
        controls.forEach(function (c) { state[c.key] = ''; });
        state.q = '';
        state.origin = (Array.isArray(q.origin) ? q.origin[0] : q.origin) || '';
        state.type = q.type || '';
        apply(true);
        shopEl.scrollIntoView({ block: 'start' });
      } catch (err) { /* fall back to the plain link */ }
    });
  });

  // Price table links jump to the bead, clearing filters if it is hidden
  Array.prototype.forEach.call(root.querySelectorAll('[data-gkrs-jump]'), function (a) {
    a.addEventListener('click', function (e) {
      var card = document.getElementById(a.dataset.gkrsJump);
      if (!card) return;
      e.preventDefault();
      if (card.hidden) {
        controls.forEach(function (c) { state[c.key] = ''; });
        state.origin = '';
        state.q = '';
        apply(true);
      }
      card.scrollIntoView({ block: 'center' });
      card.classList.add('is-flash');
      setTimeout(function () { card.classList.remove('is-flash'); }, 1600);
      var sel = card.querySelector('select, button[type="submit"]');
      if (sel) sel.focus({ preventScroll: true });
    });
  });

  /* ---------- customise pop-up (23 Oct 2026) ----------
     Opened by each card's customise icon, so the buyer stays on this page. Options, variant ids and prices come
     from the section's [data-gkrs-cz-config]: "under" for beads under Rs 1,000, "over" from Rs 1,000 (thread and
     German silver locket are free there). The add-on and the bead share a "Custom Set ID", as on the product page
     customiser. The 1 Mukhi Kaju card (data-gkrs-styles) lists its own fitting styles, which swap the bead variant. */
  var cz = (function () {
    var dlg = root.querySelector('[data-gkrs-cz]');
    var cfgEl = root.querySelector('[data-gkrs-cz-config]');
    if (!dlg || !cfgEl || typeof dlg.showModal !== 'function') return null;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (err) { return null; }
    function q(s) { return dlg.querySelector(s); }
    var nameEl = q('[data-gkrs-cz-name]'), imgEl = q('[data-gkrs-cz-img]');
    var sizeWrap = q('[data-gkrs-cz-size-wrap]'), sizeSel = q('[data-gkrs-cz-size]');
    var list = q('[data-gkrs-cz-opts]'), threadWrap = q('[data-gkrs-cz-thread]'), colour = q('[data-gkrs-cz-colour]');
    var freeEl = q('[data-gkrs-cz-free]'), labIncEl = q('[data-gkrs-cz-labinc]'), labEl = q('[data-gkrs-cz-lab]');
    var labIncText = q('[data-gkrs-cz-labinc-t]');
    var labIn = labEl && labEl.querySelector('input');
    var qtyEl = q('[data-gkrs-cz-qty]'), addBtn = q('[data-gkrs-cz-add]');
    var totalEl = q('[data-gkrs-cz-total]'), shipEl = q('[data-gkrs-cz-ship]'), msgEl = q('[data-gkrs-cz-msg]');
    var reportVariant = reportBtn ? Number(reportBtn.getAttribute('data-variant')) : 0;
    var limit = Number(cfg.limit) || 100000;
    var LOCKET_ICON = '<svg aria-hidden="true" focusable="false" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M8 3c0 2 1.8 3.5 4 3.5S16 5 16 3"/><circle cx="12" cy="14" r="6"/><circle cx="12" cy="14" r="2.5"/></svg>';
    var card = null, styles = null, opts = [], choice = 'loose', cardImg = '';

    function fmt(paise) { return '₹' + new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(paise / 100); }
    // "Thread" -> "thread", "German silver locket" stays capitalised, "925 Silver Locket" unchanged
    function lcFirst(s) { return /^[A-Z][a-z]/.test(s) && !/^German/.test(s) ? s.charAt(0).toLowerCase() + s.slice(1) : s; }
    function bead() { return card._cz.current(); }
    function qtyVal() { return Math.max(1, Math.min(card ? maxQty(bead()) : 108, parseInt(qtyEl.value, 10) || 1)); }
    function selected() {
      for (var i = 0; i < opts.length; i++) { if (opts[i].key === choice) return opts[i]; }
      return opts[0];
    }
    function say(text, isError) {
      msgEl.textContent = text;
      msgEl.classList.toggle('is-error', !!isError);
    }

    // Kaju: [size, style, variant id, price, available] rows for the chosen size, plain bead first
    function styleRows() {
      var s = bead();
      return styles.filter(function (r) { return r[0] === s.size; });
    }
    function buildOptions() {
      var b = bead();
      if (styles) {
        return styleRows().map(function (r, i) {
          return { key: 'style-' + i, title: r[1], beadId: r[2], beadPrice: r[3], price: r[3] - b.price, avail: r[4] };
        });
      }
      var over = b.price >= limit;
      var out = [{ key: 'loose', title: 'Loose bead', note: 'No fitting', price: 0, avail: true, img: cardImg }];
      (cfg.options || []).forEach(function (o) {
        var v = over ? o.over : o.under;
        out.push({ key: o.key, title: o.title, note: o.note, img: o.img, thread: !!o.thread, id: v.id, price: v.price,
          avail: true, rule: o.under.price !== o.over.price, underPrice: o.under.price });
      });
      return out;
    }

    function render() {
      if (!bead()) return;
      opts = buildOptions();
      var cur = selected();
      if (!cur || !cur.avail) choice = opts[0].key;
      list.innerHTML = '';
      opts.forEach(function (o) {
        var row = document.createElement('label');
        row.className = 'gkrs-cz__opt';
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'gkrs-cz-opt';
        input.value = o.key;
        input.checked = o.key === choice;
        input.disabled = !o.avail;
        input.addEventListener('change', function () { choice = o.key; say(''); update(); });
        var pic = document.createElement('span');
        pic.className = 'gkrs-cz__img';
        if (o.img) {
          var im = document.createElement('img');
          im.src = o.img;
          im.alt = '';
          pic.appendChild(im);
        } else if (!styles) {
          pic.innerHTML = LOCKET_ICON;
        }
        var name = document.createElement('span');
        name.className = 'gkrs-cz__name';
        name.textContent = o.title;
        if (o.note) {
          var small = document.createElement('small');
          small.textContent = o.note;
          name.appendChild(small);
        }
        var price = document.createElement('span');
        price.className = 'gkrs-cz__price';
        if (!o.avail) price.textContent = 'Sold out';
        else if (o.price > 0) price.textContent = '+' + fmt(o.price);
        else if (o.key === 'loose' || styles) price.textContent = 'No charge';
        else { price.textContent = 'Free'; price.classList.add('is-free'); }
        row.appendChild(input);
        if (!styles || o.img) row.appendChild(pic);
        row.appendChild(name);
        row.appendChild(price);
        list.appendChild(row);
      });
      // Thread and German silver locket: paid under Rs 1,000, free from Rs 1,000
      var ruled = opts.filter(function (o) { return o.rule; });
      freeEl.hidden = !ruled.length;
      if (ruled.length) {
        var names = ruled.map(function (o, i) { return i ? lcFirst(o.title) : o.title; }).join(' and ');
        freeEl.textContent = bead().price >= limit
          ? names + ' are free with this bead, as it is ₹1,000 or more.'
          : names + ' are ' + fmt(ruled[0].underPrice) + ' each, and free with Rudraksha of ₹1,000 or more.';
      }
      update();
    }

    function update() {
      var b = bead(), o = selected();
      if (!b || !o) return;
      threadWrap.hidden = !o.thread;
      var unit = styles ? o.beadPrice : b.price;
      var under = unit < limit;
      var included = RULES.label(unit);
      labIncEl.hidden = !included;
      if (labIncText) labIncText.textContent = included;
      if (labEl) labEl.hidden = !under || !reportVariant;
      var max = maxQty(b);
      qtyEl.max = String(max);
      if (qtyVal() > max) qtyEl.value = String(max);
      var withReport = !!(labIn && labIn.checked && labEl && !labEl.hidden);
      var n = qtyVal();
      var each = unit + (styles ? 0 : o.price) + (withReport ? Number(cfg.reportPrice) || 0 : 0);
      totalEl.innerHTML = '';
      totalEl.appendChild(document.createTextNode('Total '));
      var strong = document.createElement('strong');
      strong.textContent = fmt(each * n);
      totalEl.appendChild(strong);
      if (n > 1) totalEl.appendChild(document.createTextNode(' for ' + n + ' beads'));
      var fitted = styles ? o.price > 0 : o.key !== 'loose';
      shipEl.textContent = fitted ? '· Customised orders are usually dispatched within a week.' : '';
    }

    function open(c) {
      card = c;
      say('');
      styles = null;
      try { if (c.dataset.gkrsStyles) styles = JSON.parse(c.dataset.gkrsStyles); } catch (err) { styles = null; }
      var t = c.querySelector('.gkrs-card__title');
      nameEl.textContent = t ? t.textContent.trim() : '';
      var ci = c.querySelector('.gkrs-card__img');
      cardImg = ci ? (ci.currentSrc || ci.src) : '';
      if (cardImg) imgEl.src = cardImg; else imgEl.removeAttribute('src');
      var cs = c._cz.select;
      sizeWrap.hidden = !cs;
      sizeSel.innerHTML = '';
      if (cs) {
        Array.prototype.forEach.call(cs.options, function (o) { sizeSel.appendChild(o.cloneNode(true)); });
        sizeSel.value = cs.value;
      }
      qtyEl.value = String(Math.max(1, Math.min(108, parseInt(c._cz.qty.value, 10) || 1)));
      if (labIn) labIn.checked = !!(c._cz.labInput && c._cz.labInput.checked);
      colour.value = '';
      choice = 'loose';
      if (styles) {
        var b = bead();
        styleRows().forEach(function (r, i) { if (String(r[2]) === String(b.id)) choice = 'style-' + i; });
      }
      render();
      dlg.showModal();
      document.documentElement.classList.add('gkrs-cz-open');
    }

    sizeSel.addEventListener('change', function () { card._cz.setSize(sizeSel.value); say(''); render(); });
    colour.addEventListener('change', function () { say(''); });
    if (labIn) labIn.addEventListener('change', update);
    qtyEl.addEventListener('input', update);
    Array.prototype.forEach.call(dlg.querySelectorAll('[data-gkrs-cz-step]'), function (b) {
      b.addEventListener('click', function () {
        var want = (parseInt(qtyEl.value, 10) || 1) + Number(b.dataset.gkrsCzStep), max = maxQty(bead());
        say(want > max ? stockNote(max) : "");
        qtyEl.value = String(Math.max(1, Math.min(max, want)));
        update();
      });
    });
    q('[data-gkrs-cz-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('gkrs-cz-open'); });

    addBtn.addEventListener('click', function () {
      var b = bead(), o = selected();
      if (!b || !o) return;
      if (o.thread && !colour.value) { say('Please select a thread colour.', true); colour.focus(); return; }
      var n = qtyVal();
      qtyEl.value = String(n);
      var unit = styles ? o.beadPrice : b.price;
      var beadId = Number(styles ? o.beadId : b.id);
      var items = [];
      if (!styles && o.key !== 'loose') {
        var props = {
          'Custom Set ID': 'GK-R-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7).toUpperCase(),
          'Rudraksha Customisation': o.title,
          'For Rudraksha': nameEl.textContent + (b.size ? ' – ' + b.size : '')
        };
        if (o.thread) props['Thread Colour'] = colour.value;
        var beadProps = {};
        for (var k in props) beadProps[k] = props[k];
        beadProps.Customisation = o.title;
        items.push({ id: Number(o.id), quantity: n, properties: props });
        items.push({ id: beadId, quantity: n, properties: beadProps });
      } else {
        items.push({ id: beadId, quantity: n });
      }
      var withReport = !!(labIn && labIn.checked && labEl && !labEl.hidden && unit < limit && reportVariant);
      // Same properties as the "all beads" button, so both add to one report line
      if (withReport) items.push({ id: reportVariant, quantity: n, properties: REPORT_PROPS });
      addBtn.classList.add('is-busy');
      addBtn.setAttribute('aria-busy', 'true');
      fetch(shopRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-icon-bubble', sections_url: location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Could not add to cart');
          updateBubble(res.body.sections);
          var parts = [];
          if (b.size) parts.push(b.size + (n > 1 ? ' × ' + n : ''));
          else if (n > 1) parts.push('× ' + n);
          if (o.key !== 'loose' && !(styles && o.price === 0)) parts.push(lcFirst(o.title) + (o.thread ? ' (' + colour.value.toLowerCase() + ')' : ''));
          if (withReport) parts.push(n > 1 ? n + ' lab reports' : 'lab report');
          var c = card;
          dlg.close();
          c._cz.showMsg('Added to cart' + (parts.length ? ' (' + parts.join(', ') + ')' : '') + '. ', false, true);
          c.classList.add('is-flash');
          setTimeout(function () { c.classList.remove('is-flash'); }, 1200);
          document.dispatchEvent(new CustomEvent('gk:cart-updated', { detail: res.body }));
        })
        .catch(function (err) { say(err.message || 'Could not add to cart. Please try again.', true); })
        .then(function () { addBtn.classList.remove('is-busy'); addBtn.removeAttribute('aria-busy'); });
    });

    return { open: open };
  })();

  /* ---------- cards: size, lab report, quantity and add to cart ---------- */
  Array.prototype.forEach.call(root.querySelectorAll('[data-gkrs-form]'), function (form) {
    var card = form.closest('.gkrs-card');
    var amountEl = card.querySelector('[data-gkrs-amount]');
    var sizeLabelEl = card.querySelector('[data-gkrs-size-label]');
    var imgEl = card.querySelector('.gkrs-card__img');
    var btn = form.querySelector('[data-gkrs-add]');
    var msg = form.querySelector('[data-gkrs-msg]');
    var select = form.querySelector('[data-gkrs-size-select]');
    var single = form.querySelector('input[type="hidden"][name="id"]');
    var customise = form.querySelector('[data-gkrs-customise]');
    var labInc = form.querySelector('[data-gkrs-lab-inc]');
    var labIncText = form.querySelector('[data-gkrs-lab-inc-t]');
    var lab = form.querySelector('[data-gkrs-lab]');
    var labInput = lab && lab.querySelector('[data-gkrs-lab-input]');
    var qty = form.querySelector('input[name="quantity"]');
    var reportVariant = reportBtn ? Number(reportBtn.getAttribute('data-variant')) : 0;
    var reportLimit = reportBtn ? (Number(reportBtn.getAttribute('data-limit')) || RULES.REPORT_FROM) : RULES.REPORT_FROM;

    function current() {
      if (select) {
        var o = select.options[select.selectedIndex];
        return o ? { id: o.value, price: Number(o.dataset.price), money: o.dataset.money, size: o.dataset.size,
          max: o.dataset.max, img: o.dataset.img, srcset: o.dataset.srcset } : null;
      }
      return single ? { id: single.value, price: Number(single.dataset.price), max: single.dataset.max } : null;
    }
    function needsReport(sel) { return !!sel && sel.price < reportLimit; }

    // Price, size, photo, report status and quantity limit all follow the selected size
    function refresh() {
      var sel = current();
      if (!sel) return;
      if (select) {
        if (amountEl) amountEl.textContent = sel.money;
        if (sizeLabelEl) sizeLabelEl.textContent = sel.size;
        if (imgEl && sel.img && imgEl.getAttribute('src') !== sel.img) {
          imgEl.srcset = sel.srcset || '';
          imgEl.src = sel.img;
        }
      }
      var included = RULES.label(sel.price);
      if (labInc) labInc.hidden = !included;
      if (labIncText) labIncText.textContent = included;
      // The optional paid report exists only for beads under Rs 1,000; when hidden it is never added
      if (lab) lab.hidden = !needsReport(sel) || !reportVariant;
      var max = maxQty(sel);
      qty.max = String(max);
      if ((parseInt(qty.value, 10) || 1) > max) qty.value = String(max);
    }
    // Pick a size from the filters (cheapest matching), or back to the cheapest size (data-default)
    card._pick = function (opt) {
      if (!select) return;
      var target = opt || select.querySelector('option[data-default]');
      if (target && !target.disabled) { select.value = target.value; refresh(); }
    };
    refresh();
    if (select) select.addEventListener('change', function () { msg.textContent = ''; msg.classList.remove('is-error'); refresh(); });

    Array.prototype.forEach.call(form.querySelectorAll('[data-gkrs-step]'), function (b) {
      b.hidden = false;
      b.addEventListener('click', function () {
        var max = maxQty(current());
        var v = (parseInt(qty.value, 10) || 1) + Number(b.dataset.gkrsStep);
        if (v > max) showMsg(stockNote(max), false);
        else if (msg.textContent && !msg.classList.contains('is-error')) msg.textContent = '';
        qty.value = String(Math.max(1, Math.min(max, v)));
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var sel = current();
      if (!sel) { showMsg('Please choose a bead size first.', true); if (select) select.focus(); return; }
      var max = maxQty(sel);
      var asked = parseInt(qty.value, 10) || 1;
      if (asked > max) { qty.value = String(max); showMsg(stockNote(max), true); qty.focus(); return; }
      var q = Math.max(1, Math.min(max, asked));
      qty.value = String(q);
      var withReport = !!(labInput && labInput.checked && !lab.hidden && needsReport(sel) && reportVariant);
      var items = [{ id: Number(sel.id), quantity: q }];
      // Same properties as the "all beads" button, so both add to one report line
      if (withReport) items.push({ id: reportVariant, quantity: q, properties: REPORT_PROPS });
      btn.classList.add('is-busy');
      btn.setAttribute('aria-busy', 'true');
      fetch(shopRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-icon-bubble', sections_url: location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Could not add to cart');
          updateBubble(res.body.sections);
          var label = sel.size ? ' (' + sel.size + (q > 1 ? ' × ' + q : '') + ')' : (q > 1 ? ' (× ' + q + ')' : '');
          showMsg('Added to cart' + label + (withReport ? ' with ' + (q > 1 ? q + ' lab reports' : 'lab report') : '') + '. ', false, true);
          card.classList.add('is-flash');
          setTimeout(function () { card.classList.remove('is-flash'); }, 1200);
          document.dispatchEvent(new CustomEvent('gk:cart-updated', { detail: res.body }));
        })
        .catch(function (err) { showMsg(err.message || 'Could not add to cart. Please try again.', true); })
        .then(function () { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); });
    });

    function showMsg(text, isError, withLink) {
      msg.textContent = text;
      msg.classList.toggle('is-error', !!isError);
      if (withLink) {
        var a = document.createElement('a');
        a.href = shopRoot + 'cart';
        a.textContent = 'View cart';
        msg.appendChild(a);
      }
    }

    // What the customise pop-up needs from this card
    card._cz = {
      current: current,
      select: select,
      qty: qty,
      labInput: labInput,
      showMsg: showMsg,
      setSize: function (value) { if (select) { select.value = value; msg.textContent = ''; refresh(); } }
    };
    if (customise && cz) {
      customise.addEventListener('click', function (e) { e.preventDefault(); cz.open(card); });
    }
  });

  function updateBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var el = document.getElementById('cart-icon-bubble');
    if (!el) return;
    var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var src = doc.querySelector('.shopify-section') || doc.body;
    el.innerHTML = src.innerHTML;
  }

  /* ---------- "Request lab report for all beads" (19 Oct 2026) ----------
     Beads under Rs 1,000 need a Rs 150 GJSPC report each, whatever the order value; beads of Rs 1,000+ include it.
     Counts single beads from this page in the cart (products listed on the page, data-pids, without builder "_gk" properties and a unit
     price below data-limit, in paise) and sets the report line to that many. Builder lines are never counted. */
  if (reportBtn) {
    var reportMsg = document.querySelector('[data-gkrs-report-msg]');
    var reportVariant = Number(reportBtn.getAttribute('data-variant'));
    var reportLimit = Number(reportBtn.getAttribute('data-limit')) || 100000;
    var reportPids = reportBtn.getAttribute('data-pids') || ',';
    var reportSay = function (text, isError, withLink) {
      reportMsg.textContent = text;
      reportMsg.classList.toggle('is-error', !!isError);
      if (withLink) {
        var a = document.createElement('a');
        a.href = shopRoot + 'cart';
        a.textContent = ' View cart';
        reportMsg.appendChild(a);
      }
    };
    var isPageBead = function (item) {
      if (reportPids.indexOf(',' + item.product_id + ',') === -1) return false;
      var props = item.properties || {};
      for (var k in props) { if (k.indexOf('_gk') === 0 && props[k] !== null && props[k] !== '') return false; }
      return true;
    };
    reportBtn.addEventListener('click', function () {
      reportBtn.setAttribute('aria-busy', 'true');
      fetch(shopRoot + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var needed = 0, reportLine = null;
          cart.items.forEach(function (item) {
            if (item.variant_id === reportVariant) { reportLine = item; return; }
            if (isPageBead(item) && item.price < reportLimit) needed += item.quantity;
          });
          var have = reportLine ? reportLine.quantity : 0;
          if (needed === have) {
            if (needed === 0) reportSay('There are no beads under ₹1,000 in your cart. Beads of ₹1,000 or more already include their lab report.');
            else reportSay('Your cart already has ' + needed + ' lab report' + (needed > 1 ? 's' : '') + ' for ' + needed + ' bead' + (needed > 1 ? 's' : '') + ' under ₹1,000.', false, true);
            return null;
          }
          var req = reportLine
            ? fetch(shopRoot + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: reportLine.key, quantity: needed, sections: 'cart-icon-bubble', sections_url: location.pathname }) })
            : fetch(shopRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id: reportVariant, quantity: needed, properties: REPORT_PROPS }],
                  sections: 'cart-icon-bubble', sections_url: location.pathname }) });
          return req.then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); }).then(function (res) {
            if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Could not update the lab reports');
            updateBubble(res.body.sections);
            if (needed === 0) reportSay('Removed the lab reports: there are no beads under ₹1,000 in your cart now.', false, true);
            else reportSay('Lab reports for ' + needed + ' bead' + (needed > 1 ? 's' : '') + ' under ₹1,000 are in your cart (₹150 each).', false, true);
            document.dispatchEvent(new CustomEvent('gk:cart-updated', { detail: res.body }));
          });
        })
        .catch(function (err) { reportSay((err && err.message) || 'Could not update the lab reports. Please try again.', true); })
        .then(function () { reportBtn.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- init ---------- */
  filters.hidden = false;
  readUrl();
  lastPick = '|';
  apply(false);
})();
